function debounce(func, delay) {
    var timeout = null;

    return function(args) {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(function() {
            func(args);
        }, delay);
    };
}

var anchorsStartPosition = null;
var debouncedActivateAnchor = debounce(activateAnchor, 100);
if (document.querySelector('.js-sticky-anchors')) {
    document.addEventListener('DOMContentLoaded', function () {
        var stickyAnchors = document.querySelector('.js-sticky-anchors');
        if (stickyAnchors) {
            anchorsStartPosition = stickyAnchors.getBoundingClientRect().top;
            debouncedActivateAnchor('[data-anchor]');
        }
    });
    window.addEventListener('scroll', function () {
        debouncedActivateAnchor('[data-anchor]');
    });
}
document.addEventListener('click', function (e) {
    var target = e.target.closest('.js-sticky-anchors-item');
    if (target) {
        e.preventDefault();
        var sectionId = target.getAttribute('href').slice(1);
        scrollToSection(sectionId);
    }
});
function scrollToSection(sectionId) {
    var currentSection = document.querySelector("[data-anchor=\"".concat(sectionId, "\"]"));
    setTimeout(function () {
        currentSection.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });
    }, 1);
}
function activateAnchor(selector) {
    if (document.querySelectorAll(selector).length) {
        var elements = getElementsClosestToCenter(selector);
        var currentItem = elements[0];
        var sectionId = currentItem.item.dataset.anchor;
        var activeAnchor = document.querySelector('.js-sticky-anchors-item.active');
        if (activeAnchor) {
            activeAnchor.classList.remove('active');
        }
        var currentAnchor = document.querySelector(".js-sticky-anchors-item[href=\"#".concat(sectionId, "\"]"));
        if (currentAnchor) {
            currentAnchor.classList.add('active');
        }
    }
}
function getElementsClosestToCenter(selector) {
    var itemsList = document.querySelectorAll(selector);
    var itemsTop = [];
    itemsList.forEach(function (item) {
        itemsTop.push({
            item: item,
            top: item.getBoundingClientRect().top
        });
    });
    itemsTop.sort(function (a, b) {
        return a < 0 ? -1 : Math.abs(window.innerHeight / 2 - a.top) - Math.abs(window.innerHeight / 2 - b.top);
    });
    return itemsTop;
}